<div>
  <div class="warning-container">
    <div class="warning-inner-container">
      <h1>Warning</h1>
      <hr />
      <p>
        {{ warningMessage }}
      </p>
    </div>
  </div>
</div>
